import React, { type ReactElement } from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { WorkflowStageIcon } from 'shared/domain/workflow/types';
import { STAGE_ICON_MAP } from './constants';

export type StageIconProps = SvgIconProps & {
  stageIcon: WorkflowStageIcon;
};

export function StageIcon({ stageIcon, ...rest }: StageIconProps): ReactElement {
  const IconComponent = STAGE_ICON_MAP[stageIcon];
  return <IconComponent {...rest} />;
}

export function getStageIconComponent(
  stageIcon: WorkflowStageIcon
): React.ComponentType<SvgIconProps> {
  return STAGE_ICON_MAP[stageIcon];
}
